import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { G_TagsTypeViewModel } from 'src/app/viewmodels/g-settings/G_TagsTypeViewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { GItemDefiningViewModel, GItemDefinintionAttachments, WareHouseItemViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SaveGItemDefinintionAttachmentRequest, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
//import Quagga from 'quagga'; 

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRef: BsModalRef;
  public itemVm: SaveItemRequest = new SaveItemRequest();
  public wareHouseItemVm: WareHouseItemViewModel = new WareHouseItemViewModel();
  public wareHouseItemList: Array<WareHouseItemViewModel> = [];
  public uploadObj: any = {
    file: ''
  }
  public vmListItems: any = [];
  public SortBy: string = "asc";
  public component_Title = 'Item';
  public exportFormat: string = 'csv';
  startDate: any = null;
  endDate: any = null;
  public itemFiles: File[] = [];
  public categoryFiles: File[] = [];
  public itemId: number = null;
  public itemAttachments: any = [];
  public categoryAttachments: any = [];
  public imageId: number;
  currentUser: any = {};


  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';

  public deleteId: string;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer
  ) {
    this.currentUser = this._uow.authenticationService.getUser();
  }

  ngOnInit() {
    this.spinner.show();
    this.itemVm = new SaveItemRequest();
    this.getItemTypes().then(() => {
      this.getList();
    });
  }


  ngAfterViewInit() {
  }

  itemTypes = [];
  getItemTypes() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
        debugger
        this.itemTypes = res.result;
        this.itemType = this.itemTypes[0];
        resolve(res);
        // this.getList();
      }, (err) =>
        this._uow.logger.log(err));
    });
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSettingService.getList("GSetting", "GetItemsAsync", this.p, this.size, search, this.orderBy, this.sort, this.itemType.name)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }

  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
  }
  openExcelModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
  }
  openModalXL(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
    this.modalRef.setClass('modal-xl');
  }

  public itemType = new ItemViewModel1();
  loadList(flag) {
    debugger
    this.itemVm = new SaveItemRequest();
    this.itemVm.itemType = new ItemViewModel1(flag.id, flag.name);
    this.itemType = new ItemViewModel1(flag.id, flag.name);
    this.getList();
  }
  // getSortIndexList(sIndex) {
  //   debugger
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.itemService.GetPagedResultBySort(0, 50, AppConsts.ITEM, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this.spinner.hide();
  //   });
  // }
  // getList() {
  //   // this._jq.showSpinner(true);
  //   // this.spinner.show();
  //   this._uow.itemService.GetPagedResult(0, 50, this.itemType.Name, 0, this.searchTerm).subscribe((res: any) => {
  //     this.vmListItems = [];
  //     this.p = 1;
  //     this.vmListItems = res.DtlList;
  //     console.log(res);

  //     // this._jq.initDataTable();
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Something Went wrong',
  //       'error'
  //     );
  //   });
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template, 1);
    this.modalRefLv1.setClass('modal-xl');
    if (model !== undefined) {
      this.itemVm = model;
      this.itemVm.itemType = this.itemType;
    } else {
      this.itemVm = undefined;
    }
  }

  openSaveOrUpdateModelForItemType(template: TemplateRef<any>, model?, itemType?) {
    debugger
    this.itemType = this.itemTypes[itemType];
    this.getList();
    this.openSaveOrUpdateModel(template, model);
  }
  openuploadExcelModal(template: TemplateRef<any>) {
    this.openExcelModal(template)
  }
  openWareHouseItemModal(template: TemplateRef<any>, model?) {
    debugger
    this.wareHouseItemVm.FK_Item_Id = new ItemViewModel(model.id, model.name);
    // this._uow.wareHouseItemService.GetG_WareHouseItemList(model.Id).subscribe((res:any)=>{
    //   console.log('list ware house item',res);
    //   this.wareHouseItemList = res;
    // });
    this.openModalXL(template);
  }
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     this.spinner.show();
  //     this.getList();
  //     // // this._jq.showSpinner(true);
  //     // this.spinner.show();
  //     // this._uow.itemService.GetPagedBySearch(this.searchTerm, this.itemType).subscribe((res: any) => {
  //     //   this.vmListItems = res.DtlList;
  //     //   // this._jq.showSpinner();
  //     //   this.spinner.hide();
  //     // }, (error) => {
  //     //   console.log(error);
  //     //   // this._jq.showSpinner();
  //     //   this.spinner.hide();
  //     // });
  //   }
  //   else {
  //     this.getList();
  //   }
  // }
  // extrnal components
  onItemSubmitted(e) {
    debugger
    console.log(e);
    if (e === true) {
      this.itemVm = new SaveItemRequest();
      this.getList();
    }
  }
  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    }
  }

  conformDelete() {
    // this._uow.itemService.Delete(this.itemVm).subscribe((res: any) => {
    //   this.getList();
    //   this.modalRefLv1.hide();
    // }, (err) => {
    //   this._jq.showSpinner();
    // });
  }
  public uploadFlag: boolean = false;
  attachfile(event) {
    if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      event.target.files[0].Name = '';
      this.uploadFlag = true;
      return;
    }
    else {
      this.uploadFlag = false;
      this.itemVm.file = event.target.files[0];
    }
    console.log(event.target.files[0]);
    // event.target.files[0]
  }
  onclick(event) {
    event.target.value = '';
    this.itemVm.file = undefined;
  }
  uploadExcel() {
    debugger
    this.spinner.show();
    this._uow.gSettingService.SaveItemFromExcelAsync(this.itemVm).toPromise().then((res: any) => {
      this.spinner.hide();
      Swal.fire('Uploaded!',
        'Excel Uploaded!',
        'success');
      this.getItemTypes();
      this.modalRef.hide();
    }).catch(error => {
      this.spinner.hide();
      Swal.fire('Failure!',
        'Not Uploaded!',
        'error');
    });
  }

  openExportModel(template: TemplateRef<any>) {
    this.openExcelModal(template);
  }

  exportToExcel() {
    debugger;
    this.spinner.show();
    // var obj = new ExportExcel();
    // obj = {

    //   StartDate: this.startDate,
    //   EndDate: this.endDate,
    //   Format: this.exportFormat
    // }
    this._uow.gSettingService.GetItemsExportAsync(this.itemType.name, this.startDate, this.endDate).subscribe((res: any) => {
      debugger;
      this.openLinkInNewTab(res.file);
      this.spinner.hide();
      this.modalRef.hide();
    },
      (error) => {
        this._uow.logger.log(error);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          'Network Issue!',
          'error'
        )
      });
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }

  openItemImageModal(template: TemplateRef<any>, model?) {
    debugger;
    this.itemId = model.id;
    this.openModalXL(template);
    this.showImages(this.itemId);

  }
  showImages(Id) {
    debugger;
    this.spinner.show();
    this._uow.gSettingService.GetItemAttachmentsAsync(Id).subscribe((res: any) => {
      debugger;
      this.itemAttachments = res.result.filter(item => item.type === 1);
      this.categoryAttachments = res.result.filter(item => item.type === 2);
      this.spinner.hide();
    });
  }
  onItemSelect(e) {
    console.log(e);
    this.itemFiles.push(...e.addedFiles);

  }

  onItemRemove(e) {
    console.log(e);
    this.itemFiles.splice(this.itemFiles.indexOf(e), 1);
  }

  onCategorySelect(e) {
    console.log(e);
    this.categoryFiles.push(...e.addedFiles);

    //this.vm.file = this.files;
  }

  onCategoryRemove(e) {
    console.log(e);
    this.categoryFiles.splice(this.categoryFiles.indexOf(e), 1);
  }

  saveImages() {
    debugger;
    this.spinner.show();
    var obj: SaveGItemDefinintionAttachmentRequest = new SaveGItemDefinintionAttachmentRequest();
    obj = {
      fkGItemDefiningId: this.itemId,
      itemFiles: this.itemFiles,
      categoryFile: this.categoryFiles
    }
    this._uow.gSettingService.SaveGItemAttachmentAsync(obj).subscribe((res: any) => {
      this.showImages(this.itemId);
      this.itemFiles = [];
      this.categoryFiles = [];
      this.spinner.hide();
    });
  }
  deleteImage(Id) {
    this.spinner.show();
    this._uow.gSettingService.DeleteItemAttachmentAsync(Id).subscribe((res: any) => {
      debugger;
      this.showImages(this.itemId);
      this.spinner.hide();
    });
  }
  transform(file: File): SafeUrl {
    debugger;
    const url = URL.createObjectURL(file);
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  onPrimaryChange(e) {
    debugger
    console.log(e)
    this.spinner.show();
    this._uow.gSettingService.MarkItemAttachmentPrimaryAsync(e.fkGItemDefiningId, e.id, e.type).subscribe((res: any) => {
      debugger;
      this.showImages(this.itemId);
      this.spinner.hide();
    });
  }
  openImageDeleteModel(template: TemplateRef<any>, model) {
    debugger
    this.openModal(template, 1);
    if (model !== undefined) {
      this.imageId = model;
    }
  }

  confirmImageDelete() {
    debugger;
    this.deleteImage(this.imageId);
    this.modalRefLv1.hide();
  }

  downloadWarehouseItems(){
     debugger;
    this.spinner.show();
    this._uow.gSettingService.DownloadItemExcelAsync().subscribe((res: any) => {
      debugger;
      this.openLinkInNewTab(res.file);
      this.spinner.hide();
      this.modalRef.hide();
    },
      (error) => {
        this._uow.logger.log(error);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          'Network Issue!',
          'error'
        )
      });
  }

  uploadItemExcel() {
    debugger
    this.spinner.show();
    this._uow.gSettingService.UpdateItemFromExcelAsync(this.itemVm).toPromise().then((res: any) => {
      this.spinner.hide();
      Swal.fire('Uploaded!',
        'Excel Uploaded!',
        'success');
      this.getItemTypes();
      this.modalRef.hide();
    }).catch(error => {
      this.spinner.hide();
      Swal.fire('Failure!',
        'Not Uploaded!',
        'error');
    });
  }

}
